<script>
  import { onMount, onDestroy, createEventDispatcher } from "svelte";
  import { fade, fly, blur } from "svelte/transition";
  import Portal from "svelte-portal";

  export let visible = false;
  export let width = "650px";

  const dispatch = createEventDispatcher();

  export let attached = () => {};

  function close(value) {
    visible = false;
    dispatch("close", value);
  }
</script>

<style>
  .dialog {
    position: fixed;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    z-index: 10000;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.4);
  }
  .dialog.dialog-theme-default {
    padding-bottom: 160px;
    padding-top: 60px;
    margin: auto 10px;
  }
  .dialog-overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    -webkit-backface-visibility: hidden;
    -webkit-animation: ngdialog-fadein 0.5s;
    animation: ngdialog-fadein 0.5s;
    background: transparent;
    margin-right: 0;
    padding-right: 2rem;
    -webkit-backdrop-filter: blur(16px);
    backdrop-filter: blur(16px);
  }
  .dialog.dialog-theme-default .dialog-content {
    position: relative;
    width: 650px;
    width: var(--width, 650px);
    max-width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 2.25rem 1.5rem 1.5rem 1.5rem;
    font-family: inherit;
    font-size: 1.1em;
    line-height: 1.5em;
    border-radius: var(--main-border-radius, 0.75rem);
    background-color: var(--main-card-background-color, #fff);
    color: var(--main-card-foreground-color, #202436);
  }
  .dialog-content {
    -webkit-backface-visibility: hidden;
    pointer-events: all;
  }
</style>

{#if visible === true}
  <Portal target={document.body}>
    <div
      class="dialog dialog-theme-default"
      use:attached
      transition:fade={{ delay: 0, duration: 600 }}
      role="alertdialog">
      <div class="dialog-overlay" on:click={() => close()} />
      <div
        transition:fly={{ y: -200, duration: 300 }}
        style="--width: {width}"
        class="dialog-content"
        role="document">
        <slot {close} />
      </div>
    </div>
  </Portal>
{/if}
